import { generateArraySchema, generateDateTimeSchema, generateRootObjectSchema, generateStringSchema, generateColorSchema, generateBooleanSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ButtonParticleSpec, ImageParticleSpec, TextParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Minimal Fixtures Atom", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  txtAwayTeam: TextParticleSpec.generateSchema('Away Team Name', 'Enter away team name.'),
  imageAwayTeam: ImageParticleSpec.generateSchema('Away Team Logo', 'Upload Away Team logo.'),
  matchDateTime: generateDateTimeSchema('Match Date Time', 'Enter date and time of match.'),
  matchStatus: generateStringSchema('Match Status', 'Select the present status of the match', {
    choices: ['pre', 'live', 'post'],
    choiceTitles: ['Pre', 'Live', 'Post'],
  }),
  btnActions: generateArraySchema(
    'Buttons List',
    'Enter the names of the buttons.',
    ButtonParticleSpec.generateSchema('CTA Button', 'Define CTA button.')
  ),
  btnSponsors: generateArraySchema(
    'Sponsor Buttons',
    'A list of sponsor buttons.',
    ButtonParticleSpec.generateSchema('CTA Button', 'Define CTA button.')
  ),
  showCompLogo: generateBooleanSchema('Show Competition Logo', 'Show Competition Logo', { defaultValue: false }),
  btnCupName: ButtonParticleSpec.generateSchema('Competition Name Button', 'Button for the competition name.'),
  txtMatchMonth: TextParticleSpec.generateSchema('Match Month Text', 'Month of the match date.'),
  txtMatchDay: TextParticleSpec.generateSchema('Match Day Text', 'Day of the match date.'),
  txtVersus: TextParticleSpec.generateSchema("Versus Text", "Versus text before the opponent team name."),
  txtResult: TextParticleSpec.generateSchema("Result Text", "Result text for a completed match."),
  txtLive: TextParticleSpec.generateSchema("Live Text", "Text indicating a match is live."),
  txtLiveScore: TextParticleSpec.generateSchema("Live Score Text", "Text for the live score of a match."),
  txtCountdown: TextParticleSpec.generateSchema("Countdown Text", "Text for the countdown till match time."),
  dividerColor: generateColorSchema("Divider Color", "The color of the expanded section divider."),
  dividerHeight: generateStringSchema("Divider Height", "The height of the expanded section divider."),
  topContainerHeight: generateStringSchema('Top Container Height', 'Height of Top Section Container', { defaultValue: '300px' }),
}));
